<header class="sticky" [ngClass]="class" [class.fixed]="stick && sticky">
  <div class="mobile-fix-option"></div>
  
  <!-- TOP HEADER - Solo visible en desktop -->
  <div class="top-header" *ngIf="topbar">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="header-contact">
            <ul>
              <li>Bienvenido a Arista</li>
              <li *ngIf="userId">Usuario: {{ userId }} | Tipo: {{ userType }} | Tarifa: {{ priceRateId }}</li>
              <li><i class="fa fa-phone" aria-hidden="true"></i>Llamar: 313 872 69 00</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 text-end">
          <ul class="header-dropdown">
            <li class="mobile-wishlist">
              <a [routerLink]="['/shop/cart']">
                <i class="fa fa-shopping-cart" aria-hidden="true"></i>Carrito de Compras
              </a>
            </li>
            <li class="onhover-dropdown mobile-account">
              <i class="fa fa-user" aria-hidden="true"></i> {{ name }} - {{ email }}
              <ul class="onhover-show-div">
                <li>
                  <a data-lng="es" (click)="closeSession()">
                    Cerrar sesión
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- BARRA MÓVIL INFERIOR - Solo visible en móvil -->
  <div class="mobile-user-bar d-md-none">
    <div class="user-info-compact">
      <i class="fa fa-user" aria-hidden="true"></i>
      <div class="user-details">
        <span class="user-name">{{ name }}</span>
        <span class="user-meta">{{ email }}</span>
      </div>
    </div>
    <div class="actions">
      <button class="btn-icon" [routerLink]="['/shop/cart']">
        <i class="fa fa-shopping-cart" aria-hidden="true"></i>
      </button>
      <button class="btn-icon" (click)="closeSession()">
        <i class="fa fa-sign-out" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <!-- MENÚ PRINCIPAL -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="main-menu">
          <div class="menu-left">
            <app-left-menu></app-left-menu>
            <div class="brand-logo">
              <a routerLink="/home/catalog" id="headerlogo">
                <img [src]="themeLogo" width="130" height="40" class="img-fluid" alt="logo" 
                     (click)="window.localStorage.removeItem('products'); window.localStorage.removeItem('start')">
              </a>
            </div>
          </div>
          <div class="menu-right pull-right">
            <div class="sub-title">
              <div class="header-title">
                <h4><br>Estado<br></h4>
              </div>
              <div class="header-contant">
                <div class="status-picker" (click)="$event.stopPropagation()">
                  <button type="button" class="status-picker__trigger" (click)="toggleStatusDropdown($event)">
                    <span class="status-picker__trigger-label">{{ selectedStatusLabel }}</span>
                    <i class="fa" [ngClass]="statusDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
                  </button>

                  <div class="status-picker__panel" *ngIf="statusDropdownOpen">
                    <div class="status-picker__search">
                      <i class="fa fa-search" aria-hidden="true"></i>
                      <input
                        type="text"
                        [(ngModel)]="statusSearchTerm"
                        placeholder="Escribe para buscar"
                        (click)="onStatusSearchClick($event)"
                      />
                    </div>

                    <div class="status-picker__options">
                      <button
                        type="button"
                        class="status-picker__option"
                        *ngFor="let option of filteredStatusOptions"
                        [class.status-picker__option--active]="option.value === statusProduct"
                        (click)="selectStatus(option.value, $event)">
                        <span>{{ option.label }}</span>
                        <i class="fa fa-check" *ngIf="option.value === statusProduct" aria-hidden="true"></i>
                      </button>

                      <div class="status-picker__empty" *ngIf="!filteredStatusOptions.length">
                        No se encontraron estados
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <app-settings></app-settings>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- Modal de Confirmación de Cierre de Sesión (Angular puro) -->
<div class="custom-modal-overlay" *ngIf="showLogoutModal" (click)="cancelLogout()">
  <div class="custom-modal" (click)="$event.stopPropagation()">
    <div class="custom-modal-header">
      <h5 class="custom-modal-title">
        <i class="fa fa-sign-out" aria-hidden="true"></i> Confirmar cierre de sesión
      </h5>
      <button type="button" class="custom-close-btn" (click)="cancelLogout()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <div class="custom-modal-body">
      <p class="mb-0">¿Está seguro que desea cerrar sesión?</p>
      <small class="text-muted">Será redirigido a la página de inicio de sesión.</small>
    </div>
    <div class="custom-modal-footer">
      <button type="button" class="btn btn-secondary" (click)="cancelLogout()">
        <i class="fa fa-times" aria-hidden="true"></i> Cancelar
      </button>
      <button type="button" class="btn btn-danger" (click)="confirmLogout()">
        <i class="fa fa-sign-out" aria-hidden="true"></i> Cerrar Sesión
      </button>
    </div>
  </div>
</div>
